import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectStoreCount, selectLoginUrl } from 'core/selectors/app';
import { selectUserIsIdentified } from 'core/selectors/user';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { triggerHomeValueBannerViewed } from './actions';
import Cookies from 'js-cookie';
import AcquisitionBonusBanner from 'org/modules/HomeTest/components/AcquisitionBonusBanner/AcquisitionBonusBanner';

import './HomeValueBanner.scss';

function HomeValueBanner() {
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const userIsIdentified = useSelector(selectUserIsIdentified);
  const storeCount = useSelector(selectStoreCount);
  const loginUrl = useSelector(selectLoginUrl);
  const hasFCookieTrue = Cookies.get('f') === 'true';
  const dispatch = useDispatch();

  const shouldShowBanner = !userIsIdentified || hasFCookieTrue;

  useEffect(() => {
    dispatch(triggerHomeValueBannerViewed());
  }, []);

  if (isMobileMQ) {
    return (
      <div className="mn_homeValueBannerTest">
        <div className="mn_contentWrap">
          <div className="mn_bannerData">
            {!userIsIdentified && <div className="mn_preHeader">United Mileageplus members</div>}
            <h2>Shop today, fly later</h2>
            <p>Earn miles towards your next trip by shopping at {storeCount}+ stores.</p>
            {!userIsIdentified && <a className="mn_button" href={loginUrl}>Sign in and shop</a>}
          </div>
        </div>
        { shouldShowBanner && <AcquisitionBonusBanner /> }
      </div>
    );
  }

  return (
    <div className="mn_homeValueBannerTest">
      <div className="mn_contentWrap">
        <div className="mn_bannerData">
          <h2>Shop today, fly later</h2>
          <p>Earn miles towards your next trip by shopping<br />at {storeCount}+ stores.</p>
          {!userIsIdentified && <a className="mn_button" href={loginUrl}>Sign in and shop</a>}
        </div>
      </div>
      { shouldShowBanner && <AcquisitionBonusBanner /> }
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><HomeValueBanner {...props} /></ComponentErrorBoundary>;
